import React, { useEffect, useState } from "react";
import { GoPlus } from "react-icons/go";
import apiRequests from "../../Component/axios/config/config";
import { useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleAddProduct = () => {
    navigate("/product/create");
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchQuery(search);
    }, 400);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setTableLoading(true);

        const profile = await apiRequests.get("/seller/v1/get-my-profile");
        const sellerType = profile.data.data.Type;

        const endpoint =
          sellerType === "CHEF"
            ? "/product/get-all-Food-seller"
            : "/product/get-all-seller";

        const products = await apiRequests.get(endpoint, {
          params: {
            page: 1,
            limit: 20,
            search: searchQuery,
          },
        });

        setProducts(products.data.data.docs);
      } catch (err) {
        setError("Unable to load products.");
      } finally {
        setLoading(false);
        setTableLoading(false);
      }
    };

    fetchData();
  }, [searchQuery]);

  if (loading) {
    return (
      <div className="w-full h-64 flex items-center justify-center text-gray-500 font-medium">
        Loading products...
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full h-64 flex items-center justify-center text-red-500 font-medium">
        {error}
      </div>
    );
  }

  return (
    <div className="w-full px-10 flex gap-6 flex-col">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-[#1f1b18]">products</h1>

        <div className="flex items-center gap-4">
          <div className="relative w-75">
            <CiSearch className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by product name..."
              className="w-full h-11 pl-11 pr-4 rounded-xl border border-gray-200
                   bg-white text-sm text-gray-700 outline-none
                   focus:border-[#024E88]"
            />
          </div>

          <button
            className="bg-[#051F33] text-white px-5 py-2.5 rounded-2xl 
                 flex items-center gap-2 font-medium hover:bg-[#082a45] 
                 transition shadow-sm"
            onClick={handleAddProduct}
          >
            <GoPlus className="text-xl" />
            Add products
          </button>
        </div>
      </div>

      <div className="w-full overflow-x-auto rounded-t-2xl relative">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gradient-to-r from-[#051F33] to-[#024E88] text-white">
              <th className="p-4 font-medium capitalize pl-8">product</th>
              <th className="p-4 font-medium capitalize text-center">status</th>
              <th className="p-4 font-medium capitalize text-center">brand</th>
              <th className="p-4 font-medium capitalize text-center">
                category
              </th>
              <th className="p-4 font-medium capitalize text-center">action</th>
            </tr>
          </thead>
          <tbody>
            {tableLoading ? (
              <tr>
                <td colSpan="5" className="p-10 text-center text-gray-500">
                  Loading...
                </td>
              </tr>
            ) : products.length > 0 ? (
              products.map((item) => (
                <tr
                  key={item._id}
                  className="border-b border-[#AE9C91] hover:bg-gray-50 h-16 transition-colors"
                >
                  <td className="p-4 pl-8">
                    <div className="flex items-center gap-4">
                      {item.image || (item.images && item.images.length > 0) ? (
                        <img
                          src={`${process.env.REACT_APP_API_URL_image}${item.images[0].path}`}
                          alt={item.name}
                          className="w-10 h-10 rounded-full object-cover shadow-sm border border-gray-100"
                        />
                      ) : (
                        <div className="w-10 h-10 rounded-full bg-gray-200 shrink-0"></div>
                      )}
                      <span className="text-gray-600 font-medium">
                        {item.name || "Unnamed Product"}
                      </span>
                    </div>
                  </td>
                  <td className="p-4 text-center">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-medium ${
                        item.is_active === true
                          ? "bg-green-100 text-green-600"
                          : "bg-yellow-100 text-yellow-600"
                      }`}
                    >
                      {item.is_active === true ? "Accepted" : "Pending"}
                    </span>
                  </td>
                  <td className="p-4 text-center text-gray-600">
                    {typeof item.brand === "object"
                      ? item.brand?.name
                      : item.brand || "-"}
                  </td>
                  <td className="p-4 text-center text-gray-600">
                    {typeof item.category === "object"
                      ? item.category?.name
                      : item.category || "-"}
                  </td>
                  <td
                    className="p-4 text-center"
                    onClick={() => {
                      navigate(`/product/detail/${item._id}`);
                    }}
                  >
                    <button className="text-cyan-500 hover:text-cyan-700 font-medium text-sm">
                      see more
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="p-10 text-center text-gray-500">
                  No products found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Products;
